import { Box, Typography } from '@mui/material';
import styled from 'styled-components';

export const DecisionIQInformationContainerStyled = styled(Box)(
  ({ theme }) => ({
    backgroundColor: '#F5EDFF',
    borderRadius: '8px',
    padding: '42px 40px',
    [theme.breakpoints.down('sm')]: {
      padding: '24px',
    },
  })
);

export const DecisionIQRowStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
});

export const DecisionIQHowOftenTextStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  justifyContent: 'center',
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
  },
}));

export const DecisionIQInfoBottomStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const PurpleLine = styled(Box)({
  width: '100%',
  height: '0px,',
  border: '0.5px solid #9747FF',
});

export const DecisionIQPrivacyContainerStyled = styled(Box)({
  backgroundColor: '#DEE7FF',
  borderRadius: '8px',
  padding: '12px 28px 12px 28px',
  display: 'flex',
  flexDirection: 'row',
});

export const DecisionIQFamilySelectListStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const LightbulbAnimationStyled = styled('img')(({ theme }) => ({
  width: '80px',
  height: '64px',
  [theme.breakpoints.down('sm')]: {
    width: '40%',
  },
}));
